import { useEffect } from "react";
import {
  captureFeature,
  captureFeatureClose,
  type FeatureUseType,
} from "src/utils/analytics.ts";

/**
 * Fires `feature_use` when a state-driven feature surface is shown, and by default
 * `feature_close` on unmount or when `isOpen` becomes false (effect cleanup).
 * Set `trackClose` to false when you call `captureFeatureClose` yourself with extra properties.
 *
 * Do not use on route-level page components — those are covered by `$pageview`.
 *
 * Without `isOpen`: fires once per mount — for components that unmount when closed.
 * With `isOpen`: fires each time `isOpen` flips true — for always-mounted components.
 */
export function useTrackFeature(
  feature: FeatureUseType,
  isOpen = true,
  trackClose = true
) {
  useEffect(() => {
    if (!isOpen) return;
    captureFeature(feature);
    if (trackClose) return () => captureFeatureClose(feature);
  }, [feature, isOpen, trackClose]);
}
